import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Aperture } from 'lucide-react';
import { Button } from '../components/ui/button';
import { PageHead } from '../components/PageHead';
import './CollectionPage.css';

export const VerresPage = () => {
  const navigate = useNavigate();

  return (
    <div className="collection-page">
      <PageHead
        title="Nos Verres Essilor – Lunetterie du Russey | Progressifs XR Design"
        description="Partenaire Essilor depuis 2014. Progressifs XR Design, verres amincis, antireflet dernière génération. Expertise adaptée aux métiers de précision du pays horloger."
        image="/essilor.jpg"
      />
      <div className="collection-page-header">
        <Button 
          variant="outline" 
          onClick={() => navigate('/')}
          className="back-button"
        >
          <ArrowLeft size={20} />
          Retour
        </Button>
      </div>

      <div className="collection-page-container">
        <div className="collection-hero blue">
          <div className="collection-hero-icon">
            <Aperture size={48} />
          </div>
          <h1 className="collection-hero-title">Nos Verres</h1>
          <p className="collection-hero-intro">
            Depuis l'ouverture du magasin en 2014, Essilor est partenaire de la Lunetterie du Russey.
          </p>
        </div>

        <div className="brands-content">
          {/* Essilor */}
          <div className="brand-section">
            <div className="brand-content-wrapper">
              <div className="brand-text">
                <h2 className="brand-title">Essilor</h2>
                <p className="brand-description">
                  La marque forme régulièrement les collaborateurs à ses nombreuses innovations. 
                  Avec 10 ans d'expérience en pays horloger, la gamme Essilor correspond tout à 
                  fait aux besoins visuels très exigeants des métiers de précision.
                </p>
              </div>
              <div className="brand-image-large">
                <img src="/essilor.jpg" alt="Verres Essilor – partenaire de la Lunetterie du Russey depuis 2014, progressifs XR Design" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
